import { useMemo } from 'react';

import { Alert, Box, Link } from '@mui/material';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import SignUpContainer, { SignUpErrorTypes } from './SignUpContainer';
import { ERROR_AUTH_INVALID_CREDENTIALS } from '../Login/LoginContainer';

const ErrorContainer = styled(Box)`
    margin-bottom: 2rem;
`;

const StyledAlert = styled(Alert)`
    margin-bottom: 1rem;
`;

const StyledLink = styled(Link)`
    cursor: pointer;
`;

const AuthError = () => {
    const { authError } = useContainer(SignUpContainer);
    const { t } = useTranslation('sign-up');

    const errorMessage = useMemo(() => {
        switch (authError) {
            case ERROR_AUTH_INVALID_CREDENTIALS:
                return t('errors.bad-sign-up-attempt');
            case SignUpErrorTypes.ERROR_AUTH_EMAIL_IN_USE:
                return t('errors.email-in-use');
            default:
                return t('errors.generic', { error: authError });
        }
    }, [authError, t]);

    if (authError === null) return null;

    const loginLink = window.location.href.replace('/sign-up', '/login');

    return (
        <ErrorContainer>
            <StyledAlert severity="error">
                <Box>{errorMessage}</Box>
                {authError === SignUpErrorTypes.ERROR_AUTH_EMAIL_IN_USE && (
                    <StyledLink href={loginLink}>{t('login')}</StyledLink>
                )}
            </StyledAlert>
        </ErrorContainer>
    );
};

export default AuthError;
